import Axios from '../Axios';

const subscription = {
	create(data) {
		return Axios.post('/subscriptions', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/subscriptions?limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/subscriptions/' + id);
	},
	update(id, data) {
		return Axios.put('/subscriptions/' + id, data);
	},
	delete(id) {
		return Axios.delete('/subscriptions/' + id);
	},
};

export default subscription;
